import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup } from "effect/unstable/httpapi";

export const GITHUB_INVALID_URL = "Invalid GitHub URL. Use a repository URL like https://github.com/owner/repo/tree/branch/path";
export const GitHubImportInput = /* @__PURE__ */ (() => Schema.Struct({ url: Schema.optionalKey(Schema.Json) }))();
export const GitHubPage = /* @__PURE__ */ (() => Schema.URLFromString.check(Schema.makeFilter(url => {
  const parts = url.pathname.split("/").filter(Boolean);
  return url.hostname === "github.com" && (parts.length === 2 || parts.length > 3 && parts[2] === "tree");
})).pipe(Schema.brand("GitHubPage")))();
export const GitHubImportResponse = /* @__PURE__ */ (() => Schema.Struct({
  files: Schema.Record(Schema.String, Schema.String),
  source: Schema.Struct({ owner: Schema.String, repo: Schema.String, branch: Schema.String, path: Schema.String, url: Schema.String })
}))();
export type GitHubImportResponse = typeof GitHubImportResponse.Type;
export const GitHubRepository = /* @__PURE__ */ (() => Schema.Struct({ default_branch: Schema.optionalKey(Schema.Json) }))();
export const GitHubEntry = /* @__PURE__ */ (() => Schema.Struct({
  type: Schema.String, path: Schema.optionalKey(Schema.String), download_url: Schema.optionalKey(Schema.NullOr(Schema.String))
}))();
export type GitHubEntry = typeof GitHubEntry.Type;
const Status = /* @__PURE__ */ (() => Schema.Int.check(Schema.isBetween({ minimum: 100, maximum: 599 })))();
export const GitHubJsonReply = /* @__PURE__ */ (() => Schema.Struct({ status: Status, body: Schema.Json }))();
export type GitHubJsonReply = typeof GitHubJsonReply.Type;
export const GitHubTextReply = /* @__PURE__ */ (() => Schema.Struct({ status: Status, body: Schema.String }))();
export type GitHubTextReply = typeof GitHubTextReply.Type;
const Errors = /* @__PURE__ */ (() => [400, 404, 500].map(status => Schema.Struct({ error: Schema.String }).annotate({ httpApiStatus: status })))();
export const GitHubImportApi = HttpApiGroup.make("github").add(
  HttpApiEndpoint.post("import", "/api/github", { payload: Schema.Json, success: GitHubImportResponse, error: Errors })
);
